import { helpers } from 'vuelidate/lib/validators'

export const validNameAndSurname = helpers.regex('validName', /^[a-zA-Z\s‘’'-]*$/)
export const isDobFieldValid = (value, vm) => vm.isDobAboveCutoffAge
